export default __webpack_public_path__ + "static/media/mini-both-logo.1651aa66.svg";